module.exports = __webpack_public_path__ + "8f720777d049401b1f982a344681a456.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/invoice/sms-purchase-invoice.html
// module id = 1974
// module chunks = 0